///<reference path="presentation/components/welcome/welcome.ts"/>
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {routing} from "./routes";
import {NgsRevealModule} from "ng-scrollreveal";
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {SuiModule} from "ng2-semantic-ui";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ApiAccessService} from "./infrastructure/api/ApiAccessService";
import {TranslationService} from "./presentation/translation/TranslationService";
import {NavigationService} from "./presentation/navigation/NavigationService";
import {FakeVanService, IVanService} from "./domain/leasing/IVanService";
import {FakeUserReservationService, IUserReservationService} from "./domain/leasing/IUserReservationService";
import {FakeOccasionService, IOccasionService} from "./domain/occasions/IOccasionService";
import {OccasionService} from "./infrastructure/occasions/OccasionService";
import {VanService} from "./infrastructure/leasing/VanService";
import {UserReservationService} from "./infrastructure/leasing/UserReservationService";
import {environment} from "../environments/environment";
import {WelcomeComponent} from "./presentation/components/welcome/welcome";
import {GarageMainComponent} from "./presentation/components/garage/main/main";
import {FooterComponent} from "./presentation/components/garage/footer/footer";
import {GarageMainHeaderComponent} from "./presentation/components/garage/main/header/header";
import {GarageMainPresentationComponent} from "./presentation/components/garage/main/presentation/presentation";
import {OccasionsComponent} from "./presentation/components/garage/occasions/occasions";
import {OccasionsHeaderComponent} from "./presentation/components/garage/occasions/header/header";
import {OccasionsContentComponent} from "./presentation/components/garage/occasions/content/content";
import {OccasionsListComponent} from "./presentation/components/garage/occasions/content/occasions-list/occasions-list";
import {OccasionsLightComponent} from "./presentation/components/garage/occasions/content/occasions-light/occasions-light";
import {OccasionsFilterComponent} from "./presentation/components/garage/occasions/content/occasions-filter/occasions-filter";
import {LeasingPageComponent} from "./presentation/components/garage/leasing/leasing";
import {LeasingComponent} from "./presentation/components/garage/leasing/presentation/leasing/leasing";
import {LeasingHeaderComponent} from "./presentation/components/garage/leasing/header/header";
import {LeasingPresentationComponent} from "./presentation/components/garage/leasing/presentation/presentation";
import {TripsComponent} from "./presentation/components/trips/trips";
import {TripsHeaderComponent} from "./presentation/components/trips/header/header";
import {TripsPresentationComponent} from "./presentation/components/trips/presentation/presentation";
import {EmployeeComponent} from "./presentation/components/garage/main/presentation/employee/employee";
import {NewCarPresentationComponent} from "./presentation/components/garage/new-car/presentation/presentation";
import {NewCarHeaderComponent} from "./presentation/components/garage/new-car/header/header";
import {NewCarComponent} from "./presentation/components/garage/new-car/new-car";
import {DeviceInfo} from "./presentation/device/DeviceInfo";
import {IDeviceInfo} from "./presentation/device/IDeviceInfo";
import {CalendarComponent} from "./presentation/components/garage/leasing/presentation/userReservation/calendar/calendar";
import {UserComponent} from "./presentation/components/garage/leasing/presentation/userReservation/user/user";
import {SlotComponent} from "./presentation/components/garage/leasing/presentation/userReservation/calendar/slot/slot";
import {EmptySlotComponent} from "./presentation/components/garage/leasing/presentation/userReservation/calendar/emptySlot/emptySlot";
import {DaySlotComponent} from "./presentation/components/garage/leasing/presentation/userReservation/calendar/slot/daySlot/daySlot";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HeaderAdminNavbarComponent} from "./presentation/components/admin/navbar/header-navbar/HeaderAdminNavbar";
import {TopAdminNavbarComponent} from "./presentation/components/admin/navbar/top-navbar/TopAdminNavbar";
import {HeaderGarageNavbarComponent} from "./presentation/components/garage/navbar/header-navbar/HeaderGarageNavbar";
import {TopGarageNavbarComponent} from "./presentation/components/garage/navbar/top-navbar/TopGarageNavbar";
import {HeaderTripsNavbarComponent} from "./presentation/components/trips/navbar/header-navbar/HeaderTripsNavbar";
import {AdminHeaderComponent} from "./presentation/components/admin/header/header";
import {AdminOccasionsComponent} from "./presentation/components/admin/occasions/occasions";
import {AdminOccasionsPresentationComponent} from "./presentation/components/admin/occasions/presentation/presentation";
import {AdminLeasingComponent} from "./presentation/components/admin/leasing/leasing";
import {AdminLeasingPresentationComponent} from "./presentation/components/admin/leasing/presentation/presentation";
import {AdminReservationsComponent} from "./presentation/components/admin/reservations/reservations";
import {AdminReservationsPresentationComponent} from "./presentation/components/admin/reservations/presentation/presentation";
import {AdminWebmasterComponent} from "./presentation/components/admin/webmaster/webmaster";
import {AdminWebmasterPresentationComponent} from "./presentation/components/admin/webmaster/presentation/presentation";
import {AdminOccasionComponent} from "./presentation/components/admin/occasions/presentation/adminOccasion/adminOccasion";
import {AdminOccasionFilterComponent} from "./presentation/components/admin/occasions/presentation/adminOccasionFilter/adminOccasionFilter";
import {WaitingPopupComponent} from "./presentation/components/generic/popup/waitingPopup/waitingPopup";
import {FakeServerService, IServerService} from "./domain/server/IServerService";
import {ServerService} from "./infrastructure/server/ServerService";
import {AdminVanTypeComponent} from "./presentation/components/admin/leasing/presentation/leasing/leasing";
import {VanDetailsComponent} from "./presentation/components/admin/leasing/presentation/vanEditComponent/vanDetails/vanDetails";
import {VanEditComponent} from "./presentation/components/admin/leasing/presentation/vanEditComponent/vanEdit";
import {AdminUserReservationComponent} from "./presentation/components/admin/reservations/presentation/adminUserReservation/adminUserReservation";
import {ErrorPopupComponent} from "./presentation/components/generic/popup/errorPopup/errorPopup";
import {FakeContactService, IContactService} from "./domain/mailing/IContactService";
import {ContactService} from "./infrastructure/mailing/ContactService";
import {ContactComponent} from "./presentation/components/generic/contact/contact";
import {AdminMainPageComponent} from "./presentation/components/admin/mainPage/mainPage";
import {FakeAuthenticationService, IAuthenticationService} from "./domain/server/IAuthenticationService";
import {AuthenticationService} from "./infrastructure/server/AuthenticationService";
import {IsAdminAuthenticationGuard} from "./infrastructure/server/RouteGardService";
import {BrandComponent} from "./presentation/components/garage/new-car/presentation/brand/brand";
import {UserReservationAdminEditComponent} from "./presentation/components/garage/leasing/presentation/userReservation/userReservationAdminEdit";
import {UserReservationUserEditComponent} from "./presentation/components/garage/leasing/presentation/userReservation/userReservationUserEdit";
import {FacebookModule, FacebookService} from "ngx-facebook";
import {FakeSchiltzFacebookService, ISchiltzFacebookService} from "./domain/facebook/ISchiltzFacebookService";
import {SchiltzFacebookService} from "./infrastructure/facebook/SchiltzFacebookService";
import {TopTripsNavbarComponent} from "./presentation/components/trips/navbar/top-navbar/TopTripsNavbar";
import {StringPopupComponent} from "./presentation/components/generic/popup/stringPopup/stringPopup";
import {LeasingDetailsComponent} from "./presentation/components/garage/leasing/presentation/leasing/leasingDetails/leasingDetails";
import {UnavailabilityComponent} from "./presentation/components/garage/leasing/presentation/unavailability/unavailability";
import {FakeUnavailabilityService, IUnavailabilityService} from "./domain/leasing/IUnavailabilityService";
import {UnavailabilityService} from "./infrastructure/leasing/UnavailabilityService";
import {InfoPopupComponent} from "./presentation/components/generic/popup/infoPopup/infoPopup";
import {AdminEmployeesComponent} from "./presentation/components/admin/employees/employees";
import {FakeEmployeesService, IEmployeesService} from "./domain/employees/IEmployeesService";
import {EmployeesService} from "./infrastructure/employees/EmployeesService";
import {AdminEmployeeComponent} from "./presentation/components/admin/employees/employee/employee";
import {FakeFileUploadService, IFileUploadService} from "./domain/files/IFileUploadService";
import {S3BucketUploadService} from "./domain/files/S3BucketUploadService";
import {PictureUploadComponent} from "./presentation/components/picture-upload/picture-upload";
import {FakeRecaptchaService, IRecaptchaService} from "./infrastructure/Recaptcha/IRecaptchaService";
import {RecaptchaService} from "./infrastructure/Recaptcha/RecaptchaService";
import {PrivacyPolicyComponent} from "./presentation/components/privacy-policy/privacy-policy";
import {IGrpdPService} from "./infrastructure/privacy-policy/IGrpdPService";
import {GrpdService} from "./infrastructure/privacy-policy/GrpdService";
import {ILocalStorage} from "./infrastructure/privacy-policy/ILocalStorage";
import {LocalStorage} from "./infrastructure/privacy-policy/LocalStorage";
import {PrivacyFooterWelcomePageComponent} from "./presentation/components/privacy-policy/footer/PrivacyFooterWelcomePageComponent";
import {PrivacyFooterComponent} from "./presentation/components/privacy-policy/footer/PrivacyFooterComponent";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        WelcomeComponent,
        TopGarageNavbarComponent,
        HeaderGarageNavbarComponent,
        HeaderAdminNavbarComponent,
        TopAdminNavbarComponent,
        HeaderTripsNavbarComponent,
        FooterComponent,
        GarageMainComponent,
        GarageMainHeaderComponent,
        GarageMainPresentationComponent,
        OccasionsComponent,
        OccasionsHeaderComponent,
        OccasionsContentComponent,
        OccasionsListComponent,
        OccasionsLightComponent,
        OccasionsFilterComponent,
        LeasingPageComponent,
        LeasingComponent,
        LeasingHeaderComponent,
        LeasingPresentationComponent,
        CalendarComponent,
        SlotComponent,
        EmptySlotComponent,
        DaySlotComponent,
        UserComponent,
        TripsComponent,
        TripsHeaderComponent,
        TripsPresentationComponent,
        EmployeeComponent,
        NewCarComponent,
        NewCarHeaderComponent,
        NewCarPresentationComponent,
        AdminHeaderComponent,
        AdminOccasionsComponent,
        AdminOccasionsPresentationComponent,
        AdminLeasingComponent,
        AdminLeasingPresentationComponent,
        AdminReservationsComponent,
        AdminReservationsPresentationComponent,
        AdminWebmasterComponent,
        AdminWebmasterPresentationComponent,
        AdminOccasionComponent,
        AdminOccasionFilterComponent,
        AdminVanTypeComponent,
        VanEditComponent,
        VanDetailsComponent,
        AdminUserReservationComponent,
        AdminMainPageComponent,
        WaitingPopupComponent,
        ErrorPopupComponent,
        StringPopupComponent,
        InfoPopupComponent,
        ContactComponent,
        BrandComponent,
        UserReservationAdminEditComponent,
        UserReservationUserEditComponent,
        TopTripsNavbarComponent,
        LeasingDetailsComponent,
        UnavailabilityComponent,
        AdminEmployeesComponent,
        AdminEmployeeComponent,
        PictureUploadComponent,
        PrivacyPolicyComponent,
        PrivacyFooterWelcomePageComponent,
        PrivacyFooterComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        routing,
        NgsRevealModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SuiModule
    ],
    providers: [
        FacebookService,
        ApiAccessService,
        TranslationService,
        IsAdminAuthenticationGuard,
        NavigationService,
        {provide: IGrpdPService, useClass: GrpdService},
        {provide: ILocalStorage, useClass: LocalStorage},
        {
            provide: IOccasionService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new OccasionService(apiAccessService);
                }else{
                    return new FakeOccasionService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IVanService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new VanService(apiAccessService);
                }else{
                    return new FakeVanService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IUserReservationService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new UserReservationService(apiAccessService);
                }else{
                    return new FakeUserReservationService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IUnavailabilityService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new UnavailabilityService(apiAccessService);
                }else{
                    return new FakeUnavailabilityService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IServerService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new ServerService(apiAccessService);
                }else{
                    return new FakeServerService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IAuthenticationService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new AuthenticationService(apiAccessService);
                }else{
                    return new FakeAuthenticationService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IContactService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new ContactService(apiAccessService);
                }else{
                    return new FakeContactService();
                }
            },
            deps:[ApiAccessService]
        },
        {
            provide: IEmployeesService,
            useFactory: (apiAccessService:ApiAccessService, fileUploadService:IFileUploadService) => {
                if(environment.production){
                    return new EmployeesService(apiAccessService, fileUploadService);
                }else{
                    return new FakeEmployeesService();
                }
            },
            deps:[ApiAccessService, IFileUploadService]
        },
        {
            provide: IDeviceInfo,
            useFactory: () => {
                return new DeviceInfo();
            },
            deps:[]
        },
        {
            provide: ISchiltzFacebookService,
            useFactory: (facebookService:FacebookService) => {
                if(environment.production){
                    return new SchiltzFacebookService(facebookService);
                }else{
                    return new FakeSchiltzFacebookService();
                }
            },
            deps:[FacebookService]
        },
        {
            provide: IFileUploadService,
            useFactory: (apiAccessService:ApiAccessService, httpClient:HttpClient) => {
                if(environment.production){
                    return new S3BucketUploadService(apiAccessService, httpClient);
                }else{
                    return new FakeFileUploadService();
                }
            },
            deps: [ApiAccessService, HttpClient]
        },
        {
            provide: IRecaptchaService,
            useFactory: (apiAccessService:ApiAccessService) => {
                if(environment.production){
                    return new RecaptchaService(apiAccessService);
                }else{
                    return new FakeRecaptchaService();
                }
            },
            deps: [ApiAccessService]
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/app.module.ts